import ALS_F1_CONFIG from '../config/als';
import {format} from 'date-fns';

const onlineDomain = 'qingduo.baidu.com';

const ALS_LOG_URL = 'https://als.baidu.com/elog/glog';
// als 线下debug地址
// const ALS_LOG_URL = 'http://alsoffline.baidu-int.com/elog/glog';
function imgReport(data, logUrl) {
    let image = document.createElement('img');
    const items = [];
    Object.keys(data).forEach(key => {
        if (data[key]) {
            items.push(key + '=' + encodeURIComponent(data[key]));
        }
    });
    image.onload = image.onerror = function () {
        image = image.onload = image.onerror = null;
    };
    image.src = logUrl + (logUrl.indexOf('?') < 0 ? '?' : '&') + items.join('&');
}
/*
擎舵的所有前端打点，c_id 统一为1082，c_type为every（图灵表），不同的业务场景根据data中f1-f20来区分
使用方法： sendAlsLog({f1: 'f1的值', f2: 'f2的值'...}), 每个key对应的value都是字符串
als的打点高度自由，为了减少后续维护成本，在此统一约定下f1-f20的取值规范
f1 = "场景名称", 如"homeUv"， 防止冲突，在config/als/index.js 统一维护
f2 = "用户行为类型", 如"click"、"show"
f3 = "打点固定参数", userid
f4 = "打点固定参数", 埋点时间
f5 = "打点携带的额外参数", 当前页面路由tab来源（如口播文案textCreateScript等）
f6-f10 = "业务自定"
f11 = "json字符串", 为该埋点有必要记录的附加详细信息
f12-f20为通用id，主要用于日志排查，提前占位
f12 = "taskid" 生成时的任务id
f13 = "recordid" 生成的每条结果id
f14 = "打点固定参数", optid
f15-f19 = "业务自定"
f20 = "埋点环境来源", 区分正式环境和其他测试环境

*/
export function sendAlsLog(data) {
    if (data.f11 != null && typeof data.f11 === 'object') {
        data.f11 = JSON.stringify(data.f11);
    }
    // 区分是否为正式环境
    const isOnline = Number(window.location.host === onlineDomain);
    // 添加百度统计的打点
    sendBaiduTongjiLog(data);
    if (!isOnline) {
        console.log(data);
        return false;
    }
    imgReport(Object.assign({}, data, {
        'c_id': 1082,
        'c_type': 'every',
        f1: ALS_F1_CONFIG[data.f1] || data.f1,
        f4: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        f20: isOnline,
        rand: new Date().getTime() + Math.random()
    }), ALS_LOG_URL);
}

// 添加百度统计的事件打点
export function sendBaiduTongjiLog(data) {
    // 取出页面路径作为标签
    const pathname = window.location.pathname;
    let pathArr = pathname.split('/');
    if (pathArr.indexOf('user') >= 0) {
        pathArr.splice(pathArr.indexOf('user'), 2);
    }
    // 附加信息存进去
    let info = data.f11 != null ? data.f11 : (data.f6 || '');
    info = typeof info === 'object' ? JSON.stringify(info) : info;

    let extraField = ['f6', 'f7', 'f8', 'f9', 'f10', 'f12', 'f13', 'f16'];
    let extraInfo = {};
    extraField.forEach(field => {
        if (data[field]) {
            extraInfo[field] = (data[field] + '').slice(0, 141);
        }
    });

    // 分析模块，升级打点方法
    window._hmt.push([
        '_trackCustomEvent',
        'customevent',
        {
            userid: data.f3,
            optid: data.f14,
            pagename: data.f5,
            opename: data.f1,
            opevalue: info,
            opetype: data.f2,
            ...extraInfo
        }
    ]);
}
